import { getBooleanColor } from 'utilities/SystemUtils';
import AppChip from './AppChip';

export const AppBooleanChip = ({ value, trueIsGreen = true }: { value: boolean | null, trueIsGreen?: boolean}) => (
  <AppChip<boolean | null> value={value} getColor={() => getBooleanColor(value, trueIsGreen)} />
);

export default AppBooleanChip;